export class SidePanelRef {
  constructor(private readonly closePanel: () => void) {}

  close(): void {
    this.closePanel();
  }
}
